import React from 'react'
import {ShoppingCartOutlined} from '@ant-design/icons'

import {FLOORS} from 'lib/enumMapping'
import Heading from 'components/shared/Heading'
import Card from 'components/shared/Card'
import Price from 'components/shared/Price'
import Button from 'components/shared/Button'
import ChooseProductsButton from 'components/shared/ChooseProductsButton'
import './index.scss'

// Each product in a bundle can be modified when a bundle is chosen.
// FloorPlans for instance, should specify the number of floors inherited
// from the estate. product is mutable.
function modifyBundleProduct(product, {webOrder}) {
  switch (product.__typename) {
    case 'FloorPlansProduct':
      const floors = webOrder.floors || (webOrder.estate && webOrder.estate.floors)
      if (floors) {
        product.floors = parseInt(FLOORS[floors], 10)
      }
    // no default
  }

  return product
}

const AddToCartButton = ({
  productSelection,
  bundle,
  removeBundle,
  chooseBundle,
  ...rest
}) => {
  if (productSelection.bundleId === bundle.id) {
    return (
      <Button
        {...rest}
        icon={<ShoppingCartOutlined />}
        onClick={() => removeBundle(bundle)}
      >
        Fjern
      </Button>
    )
  }

  return (
    <Button
      {...rest}
      type="action"
      icon={<ShoppingCartOutlined />}
      onClick={() => chooseBundle(bundle)}
    >
      Velg pakke
    </Button>
  )
}

const ChooseBundle = ({
  webOrder,
  productSelection,
  productSelectionReducer,
  goToNextStep,
}) => {
  const chooseBundle = (bundle) => {
    const products = bundle.products.edges.map(e =>
      modifyBundleProduct({...e.node}, {bundle, webOrder})
    )

    productSelectionReducer({type: 'setBundle', bundle, products})
    goToNextStep()
  }

  const removeBundle = (bundle) => {
    productSelectionReducer({type: 'removeBundle', bundle})
  }

  return (
    <div className="new-order choose-bundle">
      <Heading level={2}>Velg pakke</Heading>

      <div className="order-navigation">
        <ChooseProductsButton
          size="large"
          onClick={() => goToNextStep()}
        >
          Velg produkter selv
        </ChooseProductsButton>
      </div>

      {webOrder.bundles.edges.map(({node: bundle}) => (
        <Card key={bundle.id}>
          <Card.Content>
            <div className="bundle-name">{bundle.name}</div>
            <div className="bundle-products-heading">Produkter i pakken:</div>
            <div className="bundle-products">
              {bundle.products.edges.map(({node: product}) => (
                <span key={product.id} className="bundle-product">
                  {!!product.quantity && (
                    <span className="quantity">{product.quantity}</span>
                  )}
                  <span className="name">{product.name}</span>
                </span>
              ))}
            </div>
          </Card.Content>
          <Card.Actions>
            <>
              {bundle.consumerPrice && (
                <div className="bundle-price">
                  <Price size="large" price={bundle.consumerPrice} extraText="oppsalgspris" />
                </div>
              )}
              {!bundle.consumerPrice && (
                <>
                  <div className="bundle-price">
                    <Price size="large" price={bundle.price} extraText="eks mva" />
                  </div>
                  <div className="bundle-price">
                    <Price size="medium" price={bundle.priceIncVat} extraText="ink mva" />
                  </div>
                </>
              )}
              <div className="bundle-add">
                <AddToCartButton
                  bundle={bundle}
                  productSelection={productSelection}
                  chooseBundle={chooseBundle}
                  removeBundle={removeBundle}
                />
              </div>
            </>
          </Card.Actions>
        </Card>
      ))}
    </div>
  )
}

export default ChooseBundle
